import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {BankTransferLoad} from './dto/bankTransferLoad';
import {CrudService} from './services';
import {DataListModel} from './models/data-list-model';

@Injectable( {
  providedIn: 'root'
} )

export class LoadRefundHistoryService implements CrudService<BankTransferLoad> {
  readonly apiPath = 'gps-load-history/';

  constructor( private http: HttpClient ) { }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
  ): Observable<DataListModel<BankTransferLoad>> {
    const params = new HttpParams()
      .set( 'page', pageIndex.toString() )
      .set( 'pageSize', pageSize.toString() )
      .set( 'filterString', filterString )
      .set( 'sortField', sortField )
      .set( 'sortDirection', sortDirection );
    return this.http.get( this.apiPath + 'refunded', { params } ) as Observable<DataListModel<BankTransferLoad>>;
  }

  get( id: number ): Observable<BankTransferLoad> {
    return this.http.get( this.apiPath + 'item/' + id ) as Observable<BankTransferLoad>;
  }

  add( item: BankTransferLoad ): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }

  delete(id: any): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }

  deleteMany(list: any[]): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }

  restore(id: any): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }

  restoreMany(list: any[]): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }

  update(id: any, item: BankTransferLoad): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }





}
